/**
 * Created by zhaoyue on 2019-03-31 21:18
 * 获取jwt
 * 首先引入 jsrsasign-latest-all-min.js
 * oPayload中增加nonce字段，规则是项目名+10位随机字符串，例如nonce:app5_9AVL2023UU
 */
function randomStr (n) {
  let res = ""
  for (; res.length < n; res += Math.random().toString(36).substr(2).toUpperCase()) {
  }
  return res.substr(0, n)
}

export default function getJwtSafeCode () {
  const iat = Math.floor(new Date().getTime() / 1000)
  let iss = ""
  let sec = ""
    switch (process.env.API_ENV) {
    case "production":
      // 生产环境网关配置
      iss = "gcbeEugpdgJ7rTVzFisu81VFKVFMuxjwj6"
      sec = "gcG2neanckrn8fId6yMlCZWcUp5o626b91"
      break;
    case "pre":
      // 预发布环境网关配置
      iss = "gcbeEugpdgJ7rTVzFisu81VFKVFMuxjwj6"
      sec = "gcG2neanckrn8fId6yMlCZWcUp5o626b91"
      break;
    case "testing10":
      iss = "GC6UU0FuxRWo1F7vPtEzbWCYAAFSffj6Ce"
      sec = "GCmUF9lOzp0hfyKuUcItRD5FlLzeVmZn9P"
      break;
    case "testing20":
      iss = "GC6UU0FuxRWo1F7vPtEzbWCYAAFSffj6Ce"
      sec = "GCmUF9lOzp0hfyKuUcItRD5FlLzeVmZn9P"
      break;
    case "serve":
      // // 生产环境网关配置
      // iss = "gcbeEugpdgJ7rTVzFisu81VFKVFMuxjwj6"
      // sec = "gcG2neanckrn8fId6yMlCZWcUp5o626b91"
      // 测试环境网关配置
      iss = "GC6UU0FuxRWo1F7vPtEzbWCYAAFSffj6Ce"
      sec = "GCmUF9lOzp0hfyKuUcItRD5FlLzeVmZn9P"
      break;
    default:
      // 没有匹配到具体环境的按照生产环境网关配置
      iss = ""
      sec = ""
  }
  const oHeader = {
    alg: "HS256",
    typ: "JWT",
  }
  let nonce = "GC_" + randomStr(10)
  const oPayload = {
    iss: iss,
    iat: iat,
    nbf: iat - 5,
    exp: iat + 60,
    nonce: nonce,
  }
  var sHeader = JSON.stringify(oHeader)
  var sPayload = JSON.stringify(oPayload)
  var safeCode = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, sec)
  safeCode = "GoFunBearer " + safeCode
  sessionStorage.jwtSafeCode = safeCode
  window.jwtSafeCode = safeCode
  return safeCode
}



// WEBPACK FOOTER //
// ./src/utils/config-server/jwt.js